export default {
    props: ["showPreloader"]
}